import { ModalContent, ModalHeader, ModalTitle, ModalBody, ModalCloseButton, UIText1, UIText2 } from '@cian/ui-kit';
import { IconActionClose16, IconActionLink16 } from '@cian/ui-kit-design-tokens/icons';
import {
  EType,
  ILegalInfoFieldSchema,
} from 'node/repositories/offer-card/entities/legal_info_block/LegalInfoFieldSchema';
import * as React from 'react';

import styles from './LegalInfoModal.css';

interface ILegalInfoModalProps {
  title?: string;
  fields: ILegalInfoFieldSchema[];
  onLinkClick: () => void;
}

export const LegalInfoModal: React.FC<ILegalInfoModalProps> = ({ title, fields, onLinkClick }) => {
  return (
    <ModalContent size="M">
      <ModalCloseButton title="Закрыть" size="XS" theme="fill_light" icon={<IconActionClose16 />} />
      <ModalHeader>
        <ModalTitle>{title || 'Классификация объекта'}</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <div className={styles['content']} data-testid="legal-info-modal">
          {fields.map((field, index) => (
            <div key={index} className={styles['field']}>
              <UIText2 color="text-secondary-default">{field.title}</UIText2>
              {field.type === EType.Link ? (
                <a
                  className={styles['link']}
                  href={field.value}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={onLinkClick}
                >
                  <IconActionLink16 color="text-main-default" />
                  <UIText2 color="text-main-default">{field.value}</UIText2>
                </a>
              ) : (
                <UIText1>{field.value}</UIText1>
              )}
            </div>
          ))}
        </div>
      </ModalBody>
    </ModalContent>
  );
};
